export default {
  "general": "General",
  "display": "Display",
  "quickNav": "Quick Nav",
  "links": "Links",
  "failedToSaveChanges": "Failed to save changes",
  "noCustomizationsToReset": "No customizations to reset",
  "failedToReset": "Failed to reset",
  "customized": "Customized",
  "close": "Close",
  "label": "Label",
  "displayNameForThisApplication": "Display name for this application",
  "applicationName": "Application name",
  "description": "Description",
  "shortDescriptionMax500Chars": "Short description (max 500 chars)",
  "briefDescriptionOfTheApplication": "Brief description of the application",
  "longDescription": "Long Description",
  "detailedDescriptionMax5000Chars": "Detailed description (max 5000 chars)",
  "detailedDescriptionWithMarkdownSupport": "Detailed description with markdown support",
  "features": "Features",
  "listOfKeyFeaturesMax20": "List of key features (max 20)",
  "removeFeature": "Remove feature",
  "addFeature": "Add Feature",
  "displayMode": "Display Mode",
  "howThisAppAppearsInTheDashboard": "How this app appears in the dashboard",
  "serviceShowsAsInstallableControllableService": "Service - Shows as installable/controllable service",
  "alertShowsAsInformationalBanner": "Alert - Shows as informational banner",
  "externalLinksToExternalResource": "External - Links to external resource",
  "brandIcon": "Brand Icon",
  "uploadAnImageToOverrideTheLogoBlankBundledDefault": "Upload an image to override the logo (blank = bundled default)",
  "alertConfiguration": "Alert Configuration",
  "message": "Message",
  "alertMessageToDisplay": "Alert message to display",
  "enterAlertMessage": "Enter alert message",
  "variant": "Variant",
  "alertStyle": "Alert style",
  "info": "Info",
  "success": "Success",
  "warning": "Warning",
  "muted": "Muted",
  "badgeLabel": "Badge Label",
  "optionalBadgeText": "Optional badge text",
  "eGNew": "e.g., New",
  "actionLabel": "Action Label",
  "optionalButtonText": "Optional button text",
  "eGLearnMore": "e.g., Learn More",
  "actionURL": "Action URL",
  "buttonClickDestination": "Button click destination",
  "allowAppConfigEditing": "Allow App Config Editing",
  "nonAdminUsersCanViewAndEditThisAppS": "Non-admin users can view and edit this app's config file",
  "allowNginxConfigEditing": "Allow Nginx Config Editing",
  "nonAdminUsersCanViewAndEditThisAppS2": "Non-admin users can view and edit this app's nginx config",
  "readOnlyFieldsCategoryTagsCapabilitiesRuntimeSettings": "Read-only fields: category, tags, capabilities, runtime settings",
  "showInQuickNav": "Show in Quick Nav",
  "displayThisAppInTheQuickNavigationFlyoutMenu": "Display this app in the Quick Navigation flyout menu",
  "navLabel": "Nav Label",
  "overrideLabelShownInQuickNavShorterName": "Override label shown in Quick Nav (shorter name)",
  "navIcon": "Nav Icon",
  "iconifyIconIdentifierEGLucideDownload": "Iconify icon identifier (e.g., lucide:download)",
  "minimumRole": "Minimum Role",
  "requiredRoleToSeeThisAppInQuickNav": "Required role to see this app in Quick Nav",
  "userVisibleToUsersWithGroupAccess": "User - Visible to users with group access",
  "adminAdminsOnly": "Admin - Admins only",
  "userGroups": "User Groups",
  "quickNavDisplaysAppsWithStatusBadgesUpdateIndicatorsAnd": "Quick Nav displays apps with status badges, update indicators, and labels. The main sidebar uses icons only and is not customizable per-app.",
  "customAppURL": "Custom App URL",
  "overridesTheDefaultLaunchURLInQuickNavAndApp": "Overrides the default launch URL in Quick Nav and app controls",
  "whenSetThisURLReplacesTheDefaultAppURLEverywhere": "When set, this URL replaces the default app URL everywhere — Quick Navigation, app controls, and external links. Leave blank to use the default URL based on the app's URL pattern.",
  "thisIsALinkingUtilityOnlyItDoesNotCreate": "This is a linking utility only. It does not create subdomains, DNS records, or Nginx configurations. The domain and SSL certificate must already be configured on the server before setting a custom URL here.",
  "referenceLinks": "Reference Links",
  "website": "Website",
  "officialWebsiteURL": "Official website URL",
  "gitHub": "GitHub",
  "gitHubRepositoryURL": "GitHub repository URL",
  "documentation": "Documentation",
  "officialDocumentationURL": "Official documentation URL",
  "quickBoxDocs": "QuickBox Docs",
  "quickBoxDocumentationURL": "QuickBox documentation URL",
  "resetToDefaults": "Reset to Defaults",
  "cancel": "Cancel",
  "saveChanges": "Save Changes",
  "overview": "Overview",
  "useCases": "Use Cases",
  "fields": "Fields",
  "examples": "Examples",
  "appTemplatesGuide": "App Templates Guide",
  "gotIt": "Got it",
  "whatAreAppTemplates": "What are App Templates?",
  "appTemplatesDefineHowApplicationsAppearAndBehaveInThe": "App Templates define how applications appear and behave in the QuickBox Pro dashboard. Each application (Plex, Sonarr, Nginx, etc.) has a template that controls its label, description, navigation settings, and more.",
  "howCustomizationWorks": "How Customization Works",
  "resetBehavior": "Reset Behavior",
  "clickingResetToDefaultsRemovesYourCustomizationsFromTheDatabase": "Clicking \"Reset to Defaults\" removes your customizations from the database. The app reverts to its code-defined defaults. This is safe — you can always re-customize later.",
  "appsMarkedWithCustomizedHaveAtLeastOneFieldOverridden": "Apps marked with \"Customized\" have at least one field overridden from defaults.",
  "rebranding": "Rebranding",
  "changeHowAppsAppearToYourUsers": "Change how apps appear to your users",
  "renamePlexToFamilyMediaServer": "Rename 'Plex' to 'Family Media Server'",
  "updateDescriptionsToMatchYourOrganizationSTerminology": "Update descriptions to match your organization's terminology",
  "addCustomFeatureListsHighlightingWhatYouVeConfigured": "Add custom feature lists highlighting what you've configured",
  "navigationControl": "Navigation Control",
  "customizeTheQuickNavFlyoutMenu": "Customize the Quick Nav flyout menu",
  "addFrequentlyUsedAppsToQuickNavForFastAccess": "Add frequently-used apps to Quick Nav for fast access",
  "setCustomNavLabelsShorterThanFullAppNames": "Set custom nav labels shorter than full app names",
  "chooseIconsThatMatchYourPreferences": "Choose icons that match your preferences",
  "accessControl": "Access Control",
  "controlWhatNonAdminUsersCanDo": "Control what non-admin users can do",
  "disableNginxConfigEditingForSpecificApps": "Disable nginx config editing for specific apps",
  "restrictQuickNavVisibilityToAdminsOnly": "Restrict Quick Nav visibility to admins only",
  "allowConfigEditingForSafeAppsBlockForSensitiveOnes": "Allow config editing for safe apps, block for sensitive ones",
  "displayModes": "Display Modes",
  "changeHowAppsArePresented": "Change how apps are presented",
  "showImportantNoticesAsAlertBanners": "Show important notices as 'alert' banners",
  "linkToExternalServicesWithExternalMode": "Link to external services with 'external' mode",
  "standardServiceModeForInstallableApps": "Standard 'service' mode for installable apps",
  "documentationLinks": "Documentation Links",
  "pointUsersToTheRightResources": "Point users to the right resources",
  "linkToYourInternalWikiInsteadOfOfficialDocs": "Link to your internal wiki instead of official docs",
  "addGitHubRepositoryLinksForOpenSourceTools": "Add GitHub repository links for open-source tools",
  "overrideQuickBoxDocsWithCustomGuides": "Override QuickBox docs with custom guides",
  "allCustomizableFieldsAvailableInTheTemplateEditor": "All customizable fields available in the template editor.",
  "generalTab": "General Tab",
  "displayNameShownThroughoutTheDashboard": "Display name shown throughout the dashboard",
  "shortDescriptionMax500CharsShownInAppCards": "Short description (max 500 chars) shown in app cards",
  "detailedDescriptionWithMarkdownSupportMax5000Chars": "Detailed description with markdown support (max 5000 chars)",
  "listOfKeyFeaturesMax20Items": "List of key features (max 20 items)",
  "displayTab": "Display Tab",
  "serviceInstallableAlertBannerOrExternalLink": "'service' (installable), 'alert' (banner), or 'external' (link)",
  "alertConfig": "Alert Config",
  "messageVariantBadgeAndActionButtonForAlertMode": "Message, variant, badge, and action button for alert mode",
  "nonAdminConfigAccess": "Non-Admin Config Access",
  "perAppToggleForConfigNginxEditingWhenEnabledGlobally": "Per-app toggle for config/nginx editing when enabled globally",
  "navigationTab": "Navigation Tab",
  "toggleVisibilityInTheQuickNavigationFlyout": "Toggle visibility in the Quick Navigation flyout",
  "overrideLabelShorterNameForNav": "Override label (shorter name for nav)",
  "iconifyIdentifierEGLucideDownload": "Iconify identifier (e.g., lucide:download)",
  "userForEveryoneAdminForAdminsOnly": "'user' for everyone, 'admin' for admins only",
  "linksTab": "Links Tab",
  "repositoryURL": "Repository URL",
  "officialDocsURL": "Official docs URL",
  "quickBoxSpecificDocumentationURL": "QuickBox-specific documentation URL",
  "hideAnAppFromRegularUsers": "Hide an app from regular users",
  "clickEditOnTheAppYouWantToHide": "Click 'Edit' on the app you want to hide",
  "goToTheNavigationTab": "Go to the 'Navigation' tab",
  "setMinimumRoleToAdmin": "Set 'Minimum Role' to 'Admin'",
  "saveChanges2": "Save changes",
  "theAppWillOnlyAppearInQuickNavForAdministrators": "The app will only appear in Quick Nav for administrators.",
  "rebrandAnApp": "Rebrand an app",
  "clickEditOnTheAppEGPlex": "Click 'Edit' on the app (e.g., Plex)",
  "inTheGeneralTabChangeLabelToYourPreferredName": "In the 'General' tab, change Label to your preferred name",
  "updateDescriptionToMatchYourBranding": "Update Description to match your branding",
  "theAppWillDisplayWithYourCustomNameAndDescription": "The app will display with your custom name and description everywhere.",
  "restrictConfigEditingForASensitiveApp": "Restrict config editing for a sensitive app",
  "clickEditOnASensitiveAppEGSSHNginx": "Click 'Edit' on a sensitive app (e.g., SSH, Nginx)",
  "goToTheDisplayTab": "Go to the 'Display' tab",
  "underNonAdminConfigAccessDisableBothToggles": "Under 'Non-Admin Config Access', disable both toggles",
  "nonAdminUsersWonTSeeEditConfigNginxButtons": "Non-admin users won't see Edit Config/Nginx buttons for this app, even if config editing is enabled globally.",
  "createAnAnnouncementBanner": "Create an announcement banner",
  "clickEditOnAnAppYouWantToUseAs": "Click 'Edit' on an app you want to use as a notice",
  "changeDisplayModeToAlert": "Change 'Display Mode' to 'Alert'",
  "fillInTheMessageVariantInfoWarningSuccessAndOptional": "Fill in the message, variant (info/warning/success), and optional action button",
  "theAppAppearsAsAStyledBannerInsteadOfA": "The app appears as a styled banner instead of a service card.",
  "field": "Field",
  "allCategories": "All Categories",
  "allStatus": "All Status",
  "default": "Default",
  "searchApps": "Search apps...",
  "refresh": "Refresh",
  "noAppsMatchYourFilters": "No apps match your filters",
  "noAppDefinitionsFound": "No app definitions found",
  "application": "Application",
  "category": "Category",
  "shownInQuickNavMenu": "Shown in Quick Nav menu",
  "notInQuickNav": "Not in Quick Nav",
  "enabled": "✓ Enabled",
  "disabled": "✗ Disabled",
  "status": "Status",
  "editAppTemplate": "Edit app template",
  "downloadClients": "Download Clients",
  "indexers": "Indexers",
  "mediaManagement": "Media Management",
  "mediaServers": "Media Servers",
  "mediaMonitoring": "Media Monitoring",
  "mediaRequests": "Media Requests",
  "automation": "Automation",
  "fileManagement": "File Management",
  "readers": "Readers",
  "communication": "Communication",
  "monitoring": "Monitoring",
  "utilities": "Utilities",
  "remoteAccess": "Remote Access",
  "service": "Service",
  "alert": "Alert",
  "external": "External",
  "failedToLoadAppDefinitions": "Failed to load app definitions",
  "failedToFetchApp": "Failed to fetch app",
  "failedToUpdateApp": "Failed to update app",
  "failedToResetApp": "Failed to reset app",
  "retry": "Retry",
  "appTemplates": "App Templates",
  "admin": "Admin",
  "openAppTemplatesGuide": "Open App Templates guide",
  "customizeApplicationDisplaySettingsNavigationAndDescriptions": "Customize application display settings, navigation, and descriptions.",
  "totalApps": "Total Apps",
  "defaults": "Defaults",
  "templateUpdated": "{{label}} template updated",
  "templateReset": "{{label}} reset to defaults",
  "featureNumber": "Feature {{number}}",
  "modifiedFields": "Modified: {{fields}}",
  "configAccessHeading": "Non-Admin Config Access {{condition}}",
  "configAccessCondition": "(when Config Editing is enabled)",
  "groupAccessHelp": "Configure app access per group in {{link}}",
  "defaultPattern": "QuickBox Pro uses a {{pattern}} pattern:",
  "defaultPatternName": "\"defaults-in-code, overrides-in-DB\"",
  "sourceDefaults": "{{emphasis}} are defined in the codebase and ship with updates",
  "sourceDefaultsEmphasis": "Default values",
  "customOverrides": "{{emphasis}} are stored in the database and persist across updates",
  "customOverridesEmphasis": "Your customizations",
  "runtimeMerge": "{{emphasis}}, your overrides are merged on top of defaults",
  "runtimeMergeEmphasis": "At runtime",
  "backendUnauthorized": "Unauthorized",
  "backendAdminRequired": "Admin privileges required.",
  "backendInvalidQuery": "Invalid query parameters",
  "backendInvalidAppId": "Invalid app ID",
  "backendNotFound": "App definition not found: {{appId}}",
  "backendInvalidOverride": "Invalid override payload",
  "backendUpdated": "App definition updated successfully",
  "backendSaveFailed": "Failed to save app definition",
  "backendReset": "App definition reset to defaults",
  "backendNoOverrides": "No overrides to remove"
} as const;
